import WidgetsMgr from 'widgets/widgetsMgr';

const hasContext = ctx => window.contexts.includes(ctx);

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('cart'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'cart.klarna' */ './widgets/cart/KlarnaCartMgrMixin').then(d => d.default),
    ]).then(deps => {
        const [ KlarnaCartMgrMixin] = deps;

        return {
            listId: 'cart.klarna',
            widgetsDefinition: () => [
                ['cartMgr', KlarnaCartMgrMixin, 'cartMgr']

            ]
        };
    })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('checkout'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'checkout.klarna' */ './widgets/checkout/SummaryStepKlarnaMixin').then(d => d.default),
        import(/* webpackChunkName: 'checkout.klarna' */ './widgets/checkout/PaymentAccordionItemKLARNA').then(d => d.default),
        import(/* webpackChunkName: 'checkout.klarna' */ './widgets/checkout/BillingFormKlarnaMixin').then(d => d.default)
    ]).then(deps => {
        const [
            SummaryStepKlarnaMixin,
            PaymentAccordionItemKLARNAPAYMENTS,
            BillingFormKlarnaMixin
        ] = deps;

        return {
            listId: 'checkout.klarna',
            widgetsDefinition: () => [
                ['checkoutMgr', SummaryStepKlarnaMixin, 'checkoutMgr'],
                ['paymentAccordionItemKLARNA', PaymentAccordionItemKLARNAPAYMENTS, 'paymentAccordionItem'],
                ['billingForm', BillingFormKlarnaMixin, 'billingForm']
            ]
        };
    })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp'),
    load: () => Promise.all([
        import(/* webpackChunkName: 'product.klarna' */ './widgets/product/ProductDetailKlarnaMixin').then(d => d.default),
    ]).then(deps => {
        const [ ProductDetailKlarnaMixin] = deps;

        return {
            listId: 'product.klarna',
            widgetsDefinition: () => [
                ['productDetail', ProductDetailKlarnaMixin, 'productDetail']
            ]
        };
    })
});
